export const mainFont = (fontWeight = 400, fontSize = '16px') => `
  font-family: 'Poppins', 'sans-serif';
  font-weight: ${fontWeight};
  font-size: ${fontSize};
`;

export const MJG_BLUE = '#00afec';
export const VALIDATION_RED = '#E79984';
export const SHADOW_GREY = 'rgba(102, 102, 102, 0.69)';
